<!--管家管理-->
<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 22px">
            <el-col :span="24" style="text-align: right">
                <el-button :size="size" v-permission="['SYS-HOUSEKEEPER-SAVE']" type="primary" icon="el-icon-plus" @click="showAddDialog">添加管家</el-button>
            </el-col>
        </el-row>
        <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist">
            <template v-for="(v,k) in columns">
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.prop==='photo'">
                    <template slot-scope="scope">
                        <img :src="getImg(scope.row)" class="avatar">
                    </template>
                </el-table-column>
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='startFlag'">
                    <template slot-scope="scope" style="text-align: center;">
                        <!--<i class="iconfont " v-if="!scope.row.startFlag" style="color: red">否</i>
                        <i class="iconfont " v-if="scope.row.startFlag" style="color: green">是</i>-->
                        <!--<el-switch
                                v-if="scope.row.startFlag" v-model="scope.row.startFlag"
                                active-color="#13ce66"
                                inactive-color="#ff4949" disabled>
                        </el-switch>
                        <el-switch v-permission="['SYS-HOUSEKEEPER-START']"
                                v-if="!scope.row.startFlag" v-model="scope.row.startFlag"
                                active-color="#13ce66"
                                inactive-color="#ff4949" active-text="设置为明星" @change="setStarFlag($event,scope.row)">
                        </el-switch>-->
                        <i class="el-icon-star-on " v-if="scope.row.startFlag" style="color: rgb(247, 186, 42);font-size: 40px;"></i>
                        <i class="el-icon-star-off" v-permission="['SYS-HOUSEKEEPER-START']" v-if="!scope.row.startFlag" style="color: rgb(198, 209, 222);font-size: 36px;cursor: pointer;" @click="setStarFlag(scope.row)" title="设置为明星"></i>
                        <!--<el-button v-permission="['SYS-HOUSEKEEPER-START']" v-if="!scope.row.startFlag" type="success" size="mini" icon="el-icon-edit" round @click="setStarFlag(scope.row)" >设置为明星</el-button> -->
                    </template>
                </el-table-column>
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='type'">
                    <template slot-scope="scope">
                        <span>{{getType(scope.row)}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.label==='操作'">
                    <template slot-scope="scope">
                        <el-button v-permission="['SYS-HOUSEKEEPER-UPDATE']" type="primary" icon="el-icon-edit" size="mini" round @click="showDialog(scope.row)" >编辑</el-button>
                        <!--<el-button v-permission="['SYS-HOUSEKEEPER-START']" v-if="!scope.row.startFlag" type="warning" icon="el-icon-edit" size="mini" round @click="setStarFlag(scope.row)" >设置为明星</el-button>-->
                        <el-button v-permission="['SYS-HOUSEKEEPER-DELETE']" type="danger" icon="el-icon-delete" size="mini" round @click="removeDialog(scope.row)" >删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
            </template>
        </el-table>
        <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        <el-dialog :title="titleForm"
                   width="30%"
                   @close="handleClose"
                   :visible.sync="addDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true">
            <el-form :model="editItem" :rules="editFormRules" ref="editFormRef" label-width="120px">
                <el-row>
                    <el-form-item label="姓名：" prop="name">
                        <el-input v-model="editItem.name"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="是否明星：" prop="startFlag">
                        <el-select style="width: 100%;" v-model="editItem.startFlag" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="类型：" prop="type">
                        <el-select style="width: 100%;" v-model="editItem.type" placeholder="请选择">
                            <el-option
                                    v-for="item in options1"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="照片：" prop="photo">
                        <el-upload
                                class="avatar-uploader"
                                :class="{hide:hideUploadIcon}"
                                ref="upload"
                                :action="''"
                                :multiple="false"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :limit="1"
                                :on-change="onchange"
                                :show-file-list="false"
                                :auto-upload="false">
                            <img v-if="editItem.photo" :src="productImg" class="avatar" title="点击更换照片">
                            <i v-else class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="editFun()">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {housekeeperPage, housekeeperEdit, housekeeperAdd, housekeeperStar,housekeeperRemove} from '@/api/housekeeper'
import { mapGetters } from 'vuex'
import Pagination from '@/components/pagination/index'
import {fileUp} from '@/api/file'

export default {
    name: 'SYS-HOUSEKEEPER',
    components: {
        Pagination
    },
    data() {
        return {
            options: [
                {value: true,label:'是'},
                {value: false,label:'否'}
            ],
            options1: [
                {value: 'jishi',label:'技师'},
                {value: 'kefu',label:'客服'}
            ],
            tablelist: [],
            columns:[
                {
                    label: '姓名',
                    prop: 'name',
                    width: '120px',
                    fixed: 'left'
                },{
                    label: '照片',
                    prop: 'photo'
                },{
                    label: '是否明星',
                    prop: 'startFlag',
                    width: '70px'
                },{
                    label: '类型',
                    prop: 'type',
                    width: '50px'
                },{
                    label: '操作',
                    type: 'template',
                    template: 'action',
                    fixed: 'right',
                    width: '200px'
                }
            ],
            treeTableHeight: 650,
            queryInfo: {
                pagesize: 10,
                pagenum: 1
            },
            total: 0,
            titleForm:'添加',
            disabled: true,
            addDialogVisible: false,
            editItem: {
                name: '',
                startFlag: false,
                type: 'jishi',
                photo: ''
            },
            hideUploadIcon: true,
            yulanimg: '',
            editFormRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                photo: [
                    { required: true, message: '请上传照片', trigger: 'blur' }
                ]
            },
            size:this.COMMON.size,
            loading: true
        }
    },
    methods: {
        getHeight() {
            this.treeTableHeight = window.innerHeight - 60 -55 -62 -40 -32 + 'px'
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            this.init()
        },
        /**
         * 分页组件切换页事件处理
         * @param newPage
         */
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            this.init()
        },
        init(){
            let param = {}
            // let data = {}
            param.current = this.queryInfo.pagenum
            param.size = this.queryInfo.pagesize
            this.loading = true
            housekeeperPage(param).then(response => {
                console.log('管家列表',response.data)
                this.tablelist = response.data.records
                this.total = response.data.total
                this.loading = false
            })
        },
        getImg(item){
            if (item.photo === 'undefined' || item.photo === undefined || item.photo === ''){
                // console.log('this.avatar=' + this.avatar) + '/static'
                return require('@/assets/product/default.jpg')
            }
            return this.COMMON.httpUrl + item.photo + '?token=Bearer '+ this.token
        },
        getType(item){
            // console.log(item.type)
            let arr = this.options1.filter((v)=>{ return v.value===item.type})
            // console.log(arr)
            return arr[0].label
        },
        showAddDialog(){
            this.titleForm = '添加'
            this.disabled = false
            this.addDialogVisible = true
        },
        showDialog(item){
            this.titleForm = '编辑'
            this.editItem = JSON.parse(JSON.stringify(item))
            console.log(item)
            this.disabled = false
            this.addDialogVisible = true
        },
        setStarFlag(item){
            // console.log('要设置为明星',item)
            housekeeperStar(item.id).then(response => {
                if (response.code != 200)
                    return this.$message.error(response.msg)
                this.init()
                this.$message.success(response.msg)
            })
        },
        async removeDialog(item){
            const confirmResult = await this.$confirm('此操作将删除该管家相关信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') {
                return this.$message.info('取消删除')
            }
            housekeeperRemove(item.id).then(response => {
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                this.init()
                this.$message.success(response.msg)
            })
        },
        handleClose() {
            this.$nextTick(() => {
                this.editItem = {
                    name: '',
                    photo: ''
                }
            })
            this.addDialogVisible = false
        },
        handlePreview(file) {
            console.log(file)
        },
        handleRemove(){

        },
        //当上传图片后，调用onchange方法，获取图片本地路径
        onchange(file,fileList){
            const isJPG = file.raw.type === 'image/jpeg'
            const isPNG = file.raw.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 2
            this.hideUploadIcon = fileList.length >= 1
            if (!isPNG && !isJPG) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!')
                return false
            } else if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!')
                return false
            } else if (isLt2M && (isPNG || isJPG)) {
                var _this = this
                var f = file.raw
                var reader = new FileReader()
                //转base64
                reader.onload = function(e) {
                    _this.yulanimg = e.target.result //将图片路径赋值给src
                }
                reader.readAsDataURL(f)
                // this.updataImgForm.imgname = file.name //图片的名字
                // this.updataImgForm.file = file.raw
                const formData = new FormData();
                formData.set('file', file.raw)
                formData.set('front_end','KindEditor')
                formData.set('type','housekeepers')
                fileUp(formData).then(response => {
                    if (response.code != 200)
                        return this.$message.error(response.msg)
                    this.editItem.photo = response.data.src
                    this.$message.success(response.msg)
                })
            }
        },
        editFun(){
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                if(this.titleForm==='添加'){
                    housekeeperAdd(this.editItem).then(response => {
                        if(response.code!=200){
                            return this.$message.error(this.titleForm+'失败！')
                        }
                        this.$message.success(this.titleForm+'成功！')
                        this.addDialogVisible = false
                        this.init()
                    })
                }else if(this.titleForm==='编辑'){
                    housekeeperEdit(this.editItem).then(response => {
                        if(response.code!=200){
                            return this.$message.error(this.titleForm+'失败！')
                        }
                        this.$message.success(this.titleForm+'成功！')
                        this.addDialogVisible = false
                        this.init()
                    })
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'token'
        ]),
        productImg(){
            if (this.editItem.photo === 'undefined' || this.editItem.photo === undefined || this.editItem.photo === ''){
                // console.log('this.avatar=' + this.avatar)
                return ''
            }
            //return require('@/' + this.avatar)+ '/static'
            return this.COMMON.httpUrl  + this.editItem.photo + '?token=Bearer '+ this.token
        }
    },
    created(){
        this.getHeight()
        window.addEventListener('resize', this.getHeight)
        this.init()
    },
    activated(){
        this.$refs.tableRef.doLayout()
    }
}
</script>

<style scoped>
    .avatar {
        height: 50px;
    }
</style>
